import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Input, Validator } from 'cat-ecommerce-alloy';
import Field from '@app/components/common/form/Field';
import { useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';
import styles from '../validInvalidPartsTable.module.scss';

const PartNumberInput = ({ item }) => {
  const { id, partNumber } = item;
  const { t } = useTranslation();
  const { setFieldValue } = useFormikContext();
  const validateReturnQuantity = val => {
    return new Validator(val).required(t('INVALID_ITEM_ERROR')).getError();
  };
  useEffect(() => {
    partNumber && setFieldValue(`partNumber.${id}`, partNumber);
  }, [id, partNumber, setFieldValue]);
  return (
    <div className={`${styles['partsNumberInput__container']}`}>
      <Field
        type="text"
        as={Input}
        className={`u-color--DarkGray u-fs--16 text-sans-serif`}
        id={`partNumber.${id}`}
        name={`partNumber.${id}`}
        error={t('INVALID_ITEM_ERROR')}
        validator={validateReturnQuantity}
        onChange={val => setFieldValue(`partNumber.${id}`, val)}
        errorClassName={'mb-0'}
      />
    </div>
  );
};

export default PartNumberInput;
PartNumberInput.propTypes = {
  item: PropTypes.shape({
    itemNumber: PropTypes.string,
    partNumber: PropTypes.string,
    quantity: PropTypes.string,
    assetId: PropTypes.string,
    id: PropTypes.string
  })
};
